import defaultCv from './defaultPortfolioCv.json';

export default defaultCv;
